import React from 'react'

interface AirspaceAlertProps {
    alertLabel: string
    message: string
    knowMoreText: string
    onKnowMore?: () => void
    isMobile?: boolean
    latestUpdate?: string
    lastUpdatedLabel?: string
}

const AirspaceAlert: React.FC<AirspaceAlertProps> = ({
    alertLabel,
    message,
    knowMoreText,
    onKnowMore,
    isMobile,
    latestUpdate,
    lastUpdatedLabel = 'Last updated'
}) => {
    if (isMobile) {
        return (
            <div
                style={{
                    backgroundColor: '#FFF8C4',
                    borderTop: '1.5px dashed #90CAF9',
                    borderBottom: '1.5px dashed #90CAF9',
                    padding: '12px 16px',
                    margin: 0,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                    }}
                >
                    <p
                        style={{
                            margin: 0,
                            fontSize: '14px',
                            lineHeight: '1.35',
                            color: '#1A1A1A',
                            fontFamily: 'inherit',
                            flex: 1,
                            maxWidth: 'calc(100% - 88px)',
                        }}
                    >
                        <span style={{ fontWeight: 700 }}>{alertLabel}: </span>
                        {message}
                    </p>
                    <span
                        onClick={onKnowMore}
                        style={{
                            color: '#1976D2',
                            fontSize: '14px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            lineHeight: 1,
                        }}
                    >
                        {knowMoreText}
                    </span>
                </div>
                {latestUpdate && (
                    <span
                        style={{
                            color: '#5F6368',
                            marginLeft: '0',
                            display: 'block',
                            fontSize: '10px',
                            fontWeight: 500,
                            marginTop: '6px',
                        }}
                    >
                        {lastUpdatedLabel}: {latestUpdate}
                    </span>
                )}
            </div>
        )
    }

    return (
        <div
            style={{
                backgroundColor: '#FFF8C4',
                padding: '12px 16px',
                margin: 0,
                position: 'relative',
            }}
        >
            <p
                style={{
                    margin: 0,
                    fontSize: '14px',
                    lineHeight: '1.5',
                    color: '#1A1A1A',
                    fontFamily: 'inherit',
                    textAlign: isMobile ? 'start' : 'center',
                }}

            >
                <span style={{ fontWeight: 700 }}>{alertLabel}: </span>
                {message}
                <span
                    onClick={onKnowMore}
                    style={{
                        color: '#1976D2',
                        fontWeight: 500,
                        cursor: 'pointer',
                        marginLeft: '4px',
                        marginRight: '4px',
                    }}
                >
                    {knowMoreText}
                </span>
            </p>
            {latestUpdate && !isMobile && (
                <span
                    style={{
                        position: 'absolute',
                        right: '16px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#5F6368',
                        fontSize: '10px',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {lastUpdatedLabel}: {latestUpdate}
                </span>
            )}
        </div>
    )
}

export { AirspaceAlert }
export type { AirspaceAlertProps }
